import apiClient from "../auth/apiClient";

/**
 * Service for the LPR Camera Scoring tab (AO-33366). Fetches the scoring queue
 * from search-service and persists per-read scores via lpr-service, calling the
 * gateway through the shared apiClient (mirrors LPRSearchService).
 */
class LPRScoringService {
  constructor(client) {
    this.apiClient = client;
  }

  /**
   * Fetch a page of scoreable reads plus the scored/remaining counts.
   * @param {Object} filters - { deviceIDs, startDateTime, endDateTime }
   * @param {Object} paging - { limit, offset }
   * @param {Object} cancelToken - optional axios cancel token
   */
  async getQueue(filters, paging, cancelToken) {
    return this.apiClient.post(
      "lpr-activity/scoring-queue",
      {
        deviceIDs: filters.deviceIDs,
        startDateTime: filters.startDateTime,
        endDateTime: filters.endDateTime,
        limit: paging.limit,
        offset: paging.offset,
      },
      { cancelToken }
    );
  }

  /**
   * Persist a single read's score. Mutually exclusive by contract:
   * either a numeric incorrectCharacters (0–10) with isException false,
   * or isException true with incorrectCharacters null.
   * @param {number} lprId
   * @param {Object} score - { incorrectCharacters, isException }
   */
  async saveScore(lprId, score) {
    return this.apiClient.put(`reads/${lprId}/score`, {
      incorrectCharacters: score.isException ? null : score.incorrectCharacters,
      isException: score.isException,
    });
  }

  async getCaptureImage(lprId) {
    return this.apiClient.get(`reads/${lprId}/captureimage`, {
      responseType: "blob",
    });
  }

  async getContextImage(lprId) {
    return this.apiClient.get(`reads/${lprId}/contextimage`, {
      responseType: "blob",
    });
  }
}

export default LPRScoringService;

export const lprScoringServiceInstance = new LPRScoringService(apiClient);
